const compatibility = {
    name: "Compatibility",
    path: "compatibility",
    title: "Compatibility",
    description: "Learn about browser support and compatibility with other tooling.",
    heading: false,
    exampleData: [
        {
            "title": "Browser support",
            "description": "",
            "moreDescription": "Unicss is designed for and tested on modern browsers, and the core functionality of the framework specifically depends on these browser versions:",
            "parentClass": "!bg-none !border-0",
            "example": {
                "element": "div",
                "className": "relative",
                "code": `Chrome 111 (released March 2023)
Safari 16.4 (released March 2023)
Firefox 128 (released July 2024)`
            },
            "moreexample": "If you're unsure about the support for a modern platform feature, the <a class=\"font-semibold text-color-blue-500 underline hover:decoration-thick-[2px]\" href=\"https://caniuse.com/mdn-css_at-rules_starting-style\" target=\"_blank\">Can I use</a> database is a great resource."
        }
    ]
};

export default compatibility;

<div className="text-color-blue-500 hover:underline no-underline hover:decoration-thick-[2px]"></div>